import { apiClient } from '@/utils/axios.ts'

async function getProxyCountries(): Promise<string[]> {
  const res = await apiClient.get<string[]>('/proxy/countries')

  return res.data
}

export const proxyService = {
  getProxyCountries,
}
